module.exports = __webpack_public_path__ + "images/flyclops-4794b99646cac14ba6a54232e22ef27d.png";